import { css } from 'styled-components'

import {
  backgroundTransparentActive,
  backgroundTransparentDefault,
  backgroundTransparentHover,
} from 'common-constants/colors'
import { media } from 'components/presentational'
import { DarkLightStyled } from 'components/presentational/theme/DarkLight'
import { zIndex } from 'components/presentational/zIndex'

export const panelCss = css`
  display: flex;
  min-height: 40px;
  justify-content: space-between;
  position: absolute;
  left: 20px;
  right: 20px;
  align-items: center;
  z-index: ${zIndex.base + 1};
  transform: scale(1);

  ${media.tablet`
    left: 10px;
    right: 10px;
  `};
`

export const darkPanelButtonCss = css`
  border-radius: 5px;
  background-color: ${backgroundTransparentDefault};
  font-size: 15px;
  color: var(--static-white);

  &:hover {
    background-color: ${backgroundTransparentHover};
  }

  &:active {
    background-color: ${backgroundTransparentActive};
  }
`

export const photoButtonCss = css<DarkLightStyled>`
  display: flex;
  align-items: center;
  height: 40px;
  ${(props) => props.$dark && darkPanelButtonCss}
`
